import mapValues from 'lodash/mapValues'
import axiosWrapper, { InterceptorOptions } from './axios-wrapper'
import store from '../store'
import { deleteRepairHistoryItem as deleteRepairHistoryItemAction } from '../actions/logging-actions'
import {
  setCircuitCategories,
  updateStateOfHarnesses,
  updateStateOfComponents,
  updateStateOfDevices,
  setRepairHistory,
  setBatchHistoryForComponents,
  setComponentFaultHistory,
  setComponentFaultHistoryLoading,
} from '../actions/logging-actions'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer/',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
  InterceptorOptions.noCacheInterceptor,
)

export function getCircuitCategories() {
  api
    .get(`/collection/circuit/categories?datetime=${Date.now()}`)
    .then((response) => {
      store.dispatch(setCircuitCategories(response.data))
    })
}

export function transformComponentStateResponse(componentStates) {
  return mapValues(componentStates, (componentState) => ({
    status: componentState.status,
    annotation: componentState.annotation,
    category: componentState.category,
    problemId: componentState.problem_id,
    faultLogCount: componentState.fault_log_count,
    lastFaultAt: componentState.last_fault_at,
    matchedDtcs: componentState.matched_dtcs,
    id: componentState.id,
  }))
}

export function updateCircuitState(makeModelId, vin, vehicleTestResultId) {
  const params = {
    datetime: Date.now(),
    makeModelId,
    vin,
  }
  if (vehicleTestResultId) {
    params.vehicleTestResultId = vehicleTestResultId
  }
  api
    .get('/log/problem', {
      params,
    })
    .then((response) => {
      store.dispatch(
        updateStateOfComponents(
          transformComponentStateResponse(response.data.components),
        ),
      )
      store.dispatch(updateStateOfHarnesses(response.data.harnesses))
      store.dispatch(updateStateOfDevices(response.data.devices))
    })
}

export function getRepairHistory(makeModelId, vin) {
  api
    .get(`/collection/repair-history/make_model_id/${makeModelId}/vin/${vin}`)
    .then((response) => {
      store.dispatch(setRepairHistory(response.data))
    })
}

export function deleteRepairHistoryItem(id, makeModelId, vin) {
  api.delete(`collection/repair-history/id/${id}`).then((response) => {
    if (response.status === 200) {
      store.dispatch(deleteRepairHistoryItemAction(id))
      updateCircuitState(makeModelId, vin)
    }
  })
}

export function getHistoryGroupedByComponents(
  makeModelId,
  vin,
  vehicleTestResultId,
) {
  api
    .get(
      `/log/component-histories/vehicle_test_result_id/${vehicleTestResultId}/make_model_id/${makeModelId}/vin/${vin}`,
    )
    .then((response) => {
      return store.dispatch(setBatchHistoryForComponents(response.data))
    })
}

export function getComponentFaultHistory(
  makeModelId,
  vin,
  vehicleTestResultId,
  componentId,
) {
  const params = {
    makeModelId,
    vin,
  }
  if (vehicleTestResultId) {
    params.vehicleTestResultId = vehicleTestResultId
  }
  store.dispatch(setComponentFaultHistoryLoading(componentId, true))
  return api
    .get(`/log/problem/faults/${componentId}`, {
      params,
    })
    .then((response) => {
      return store.dispatch(
        setComponentFaultHistory(componentId, response.data),
      )
    })
    .finally(() => {
      store.dispatch(setComponentFaultHistoryLoading(componentId, false))
    })
}

export function fetchVerifiedComponents(vin) {
  return api.get(`/log/verified/${vin}`)
}

export function markComponentAsVerified(vin, componentId) {
  return api.post(`/log/verified`, { vin, component_id: componentId })
}

export function unmarkComponentAsVerified(vin, componentId) {
  return api.delete(`/log/verified/${vin}/${componentId}`)
}
